/**
 * @file routes.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene todas las rutas de la aplicación
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2024-12-19
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 */

import { UserRoles } from "@/features/users";
import { Route } from "@/types/routes";

/**
 * Lista completa de rutas de la aplicación.
 * Incluye:
 * - Rutas públicas
 * - Rutas protegidas por autenticación
 * - Configuración de visualización en el sidebar
 * - Jerarquía de rutas con subrutas
 */

// Rutas públicas (auth)
export const ROUTES_PUBLIC: Route[] = [
  { pathname: "/", requiresSession: false },
  { pathname: "/login", requiresSession: false },
  { pathname: "/send-reset-email", requiresSession: false },
  { pathname: "/finish-registration", requiresSession: false },
];

// Rutas solo para admin
export const ROUTES_ADMIN: Route[] = [
  { pathname: "/users", requiresSession: true, roles: [UserRoles.ADMIN] },
  {
    pathname: "/user-activity",
    requiresSession: true,
    roles: [UserRoles.ADMIN],
  },
];

// Rutas para user normal o ambos (user y admin)
export const ROUTES_USER: Route[] = [
  {
    pathname: "/dashboard",
    requiresSession: true,
    roles: [UserRoles.USER],
  },
  {
    pathname: "/anomalies",
    requiresSession: true,
    roles: [UserRoles.USER],
  },
  {
    pathname: "/anomalies/[id]",
    requiresSession: true,
    roles: [UserRoles.USER],
  },
  {
    pathname: "/map",
    requiresSession: true,
    roles: [UserRoles.USER],
  },
  {
    pathname: "/reports",
    requiresSession: true,
    roles: [UserRoles.USER],
  },
  {
    pathname: "/signal-history",
    requiresSession: true,
    roles: [UserRoles.USER],
  },
  {
    pathname: "/signal-history/[signalId]",
    requiresSession: true,
    roles: [UserRoles.USER],
  },
  {
    pathname: "/signal-history/recordings",
    requiresSession: true,
    roles: [UserRoles.USER],
  },
  {
    pathname: "/profile",
    requiresSession: true,
    roles: [UserRoles.USER, UserRoles.ADMIN],
  },
];

// Unión de todas las rutas
export const ROUTES: Route[] = [
  ...ROUTES_PUBLIC,
  ...ROUTES_ADMIN,
  ...ROUTES_USER,
];
